import React from 'react';
import css from './css.less';
const Line = (props) => {
  const { className } = props;
  return <div className={css.line + ' ' + className || ''} />;
};
export default Line;
